<template>
    <div
        class="camelvideoAspect pointer-events-none absolute top-0 left-1/2 h-full -translate-x-1/2 z-2"
    >
        <Transition name="cardPositioning" mode="out-in">
            <div
                class="absolute -translate-1/2"
                :style="getCamelPosition(camel?.start, camel?.end, camel.step, camel.stepSizes)"
                :key="reachedStep"
                v-if="reachedStep != null"
            >
                <CamelraceCard
                    :color="camel.hexColor"
                    class="h-14 w-16 mt-20 lg:h-26 lg:w-30 lg:mt-32"
                    v-if="camel.start"
                    :style="getCamelTransforms(camel.transforms)"
                >
                    <div class="flex h-full flex-col justify-between p-2">
                        <h2 class="sectionText font-title text-center text-2xl font-black lg:text-5xl">
                            {{ camel.section }}
                        </h2>
                    </div>
                </CamelraceCard>
                <img
                    :src="turnIndicators[camel.color]"
                    :alt="$t('camelrace.turn_indicator_alt')"
                    class="w-10 absolute animate-bounce -top-5 z-20 left-1/2 -translate-x-1/2"
                    v-if="camel.isCurrentPlayersTurn"
                />
            </div>
        </Transition>
    </div>
</template>

<script>
import CamelraceCard from './CamelraceCard.vue'
import redTurn from '@/assets/images/games/camelrace/red-turn.png'
import blueTurn from '@/assets/images/games/camelrace/blue-turn.png'
import greenTurn from '@/assets/images/games/camelrace/green-turn.png'
import purpleTurn from '@/assets/images/games/camelrace/purple-turn.png'

export default {
    name: 'CamelCard',
    props: {
        camel: {
            type: Object,
            required: true,
        },
        reachedStep: {
            type: [Number, null],
            required: false,
            default: null,
        },
    },
    components: {
        CamelraceCard,
    },
    data() {
        return {
            turnIndicators: {
                red: redTurn,
                blue: blueTurn,
                green: greenTurn,
                purple: purpleTurn,
            },
        }
    },
    methods: {
        getCamelPosition(start, end, step, stepSizes = []) {
            if (
                !start?.x ||
                !start?.y ||
                !end?.x ||
                !end?.y ||
                !stepSizes ||
                stepSizes.length === 0
            ) {
                return { top: `0%`, left: `0%` }
            }
            let stepAdjusted = (step * (stepSizes[step] || 1)) / (stepSizes.length || 10)
            const x = start.x + (end.x - start.x) * stepAdjusted
            const y = start.y + (end.y - start.y) * stepAdjusted
            return { top: `${y}%`, left: `${x}%` }
        },
        getCamelTransforms(transforms = {}) {
            let transformString = 'perspective(1000rem) '
            if (transforms.rotateX) {
                transformString += ` rotateX(${transforms.rotateX}deg)`
            }
            if (transforms.rotateY) {
                transformString += ` rotateY(${transforms.rotateY}deg)`
            }
            if (transforms.rotateZ) {
                transformString += ` rotateZ(${transforms.rotateZ}deg)`
            }
            return {
                transform: transformString,
            }
        },
    },
}
</script>

<style lang="scss">
.camelvideoAspect {
    aspect-ratio: 9 / 15;
    perspective: 1200px;
}

.cardPositioning-enter-active {
    transition: all 0.3s 0s ease-in-out;
}

.cardPositioning-leave-active {
    transition: all 0.3s ease-in-out;
}

.cardPositioning-enter-from,
.cardPositioning-leave-to {
    opacity: 0;
    transform: scale(0.9);
}
</style>
